import { useSelector } from "react-redux";

type OutputTypes = {
  isAuthenticated?: boolean;
  accessToken?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  fullName?: string | null;
  email?: string | null;
  userId?: null | string | number;
  homeAddress?: any;
  phoneNumber?: number | string;
  isProfileLoaded?: boolean;
  dateOfBirth?: string;
  gender?: number;
  profileImage?: string;
  officeAddress?: any;
};

export function useProfile(): OutputTypes {
  const { profile, isAuthenticated, accessToken } = useSelector(
    (state) => state.auth
  );

  return {
    isAuthenticated,
    accessToken,
    firstName: profile?.first_name ?? null,
    lastName: profile?.last_name ?? null,
    fullName: profile?.full_name ?? null,
    email: profile?.email_id ?? null,
    userId: profile?.id ?? null,
    phoneNumber: profile?.phone_number ?? null,
    homeAddress: profile?.home_address ?? null,
    isProfileLoaded: profile?.id,
    dateOfBirth: profile?.date_of_birth ?? null,
    gender: profile?.gender ?? null,
    profileImage: profile?.photo?.image ?? null,
    officeAddress: profile?.office_address ?? null,
  };
}
